import React from "react"
import Hero from "./Hero"
import WeeklySpecials from "./WeeklySpecials"
import Reviews from "./Reviews"
import AboutUs from "./AboutUs"

export default function Home() {
    return (
        <>
        <Hero />
        <WeeklySpecials />
        <Reviews />
        <AboutUs />
        </>
    )
}